'use client'

import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  if (!mounted) {
    return null
  }
  return (
    <button
      type='button'
      className='flex h-8 items-center justify-center rounded pl-2 pr-3 transition hover:bg-zinc-200 dark:hover:bg-zinc-700'
      onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
    >
      <MoonIcon className='w-4 stroke-zinc-900 dark:hidden' />
      <SunIcon className='hidden w-4 stroke-white dark:block' />
      <span className='pl-1.5 text-sm'>{resolvedTheme === 'dark' ? 'Light' : 'Dark'}</span>
    </button>
  )
}
